import { render } from "./NortonSecuredIcon.vue?vue&type=template&id=0bc881c8"
import script from "./NortonSecuredIcon.vue?vue&type=script&lang=js"
export * from "./NortonSecuredIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__